import type { GridCellParams } from '@mui/x-data-grid-pro'

export function NameCell(params: GridCellParams) {
  return <span data-testid="orders-grid-name-value">{params.value}</span>
}
